// converts an ArcGIS epoch-milliseconds value to an ISO date-time string.
// AGO serves date-only fields as midnight UTC, and a Z-suffixed midnight parsed
// into Eastern local time lands the previous evening - so every formatted date
// showed a day early (confirmed against Eclipse: FP-2021-003472 was issued 11/4/2024
// and displayed as 11/3). Midnight values therefore become zoneless calendar dates,
// which moment parses as local; values with a real time of day keep their Z and
// stay true instants.
const epochToIso = (epoch) => {
  if (!epoch || typeof epoch !== 'number' || epoch <= 0) return null;
  const iso = new Date(epoch).toISOString().replace(/\.\d{3}Z$/, 'Z');
  return iso.endsWith('T00:00:00Z') ? iso.slice(0, -1) : iso;
};

export default epochToIso;
